import type { ClosingPackageProjection } from '../types';

const REJECTION_REASON_PREFIX = 'Причина доработки:';

export function parseRevisionRejectionReasonFromComment(
  comment: string | null | undefined
): string | null {
  const normalized = String(comment ?? '').trim();
  if (!normalized) {
    return null;
  }

  if (!normalized.startsWith(REJECTION_REASON_PREFIX)) {
    return normalized;
  }

  const withoutPrefix = normalized.slice(REJECTION_REASON_PREFIX.length).trim();
  const [reasonLine] = withoutPrefix.split('\n');
  const reason = reasonLine?.trim();
  return reason || null;
}

export function resolveRevisionRejectionReasonView(
  projection: ClosingPackageProjection | null | undefined
): {
  text: string;
  hasExplicitReason: boolean;
} {
  const metadata = projection?.workflowMetadata;
  const comment = metadata?.lastApprovalComment ?? null;
  const parsedReason = parseRevisionRejectionReasonFromComment(comment);

  if (parsedReason) {
    return { text: parsedReason, hasExplicitReason: true };
  }

  if (comment?.trim()) {
    return { text: comment.trim(), hasExplicitReason: true };
  }

  if (metadata?.lastApprovalResult === 'REJECTED') {
    const cycleLabel =
      metadata.approvalCycle > 0 ? ` (цикл ${metadata.approvalCycle - 1})` : '';
    return {
      text: `Клиент отклонил комплект${cycleLabel}. Текст причины недоступен в projection.`,
      hasExplicitReason: false,
    };
  }

  return {
    text: 'Причина доработки не указана',
    hasExplicitReason: false,
  };
}
